<template>
    <component
        :is="button.is"
        :id
        ref="element"
        :class="classThLink"
        v-bind="button.bind"
    >
        <slot name="default"></slot>
    </component>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'

import {
    useThButton,
    type ButtonProps,
} from '@/components/ui/buttons/useThButton'
import { useSlotText } from '@/components/ui/buttons/useSlotText'

const props = defineProps<ButtonProps & { id?: string }>()
const emit = defineEmits<{
    click: [v: PointerEvent]
}>()

const slots = useSlots()
const defaultSlotContent = useSlotText(slots['default'])

const button = useThButton(props, emit, defaultSlotContent)

const classThLink = computed(() => ({
    'disabled': props.disabled,
}))
</script>

<style lang="scss" scoped>
.disabled {
    pointer-events: none;
    cursor: none;
    opacity: 0.5;
}
</style>
